// extracted by mini-css-extract-plugin
module.exports = {"submit":"AvatarInput_submit__3Vwqz","submitButton":"AvatarInput_submitButton__T6kK6"};